export const formatSiteType = (siteType: string) => {
  const words = siteType?.split('_').map((word) => word.toLocaleLowerCase());
  return words?.join(' ') || '';
};
